/** Built-in jewelry customization profiles (always available; admin can hide or extend). */

export const BUILTIN_JEWELRY_PROFILES = {
  locket_photo: {
    id: 'locket_photo',
    label: 'Photo locket / pendant',
    hint: 'Customer uploads a photo to embed inside the locket. Turn on chain length in product options if you sell it with a chain.',
    fields: [
      { id: 'photo', type: 'photo', label: 'Photo for locket', required: true, hint: 'Clear front-facing photo works best.' },
      {
        id: 'chain_length',
        type: 'select',
        label: 'Chain length',
        optional: true,
        adminLabel: 'Offer chain length',
        optionsKey: 'chain',
      },
    ],
  },
  pendant_chain: {
    id: 'pendant_chain',
    label: 'Pendant + chain length',
    hint: 'Customer picks chain length — no photo upload.',
    fields: [
      { id: 'chain_length', type: 'select', label: 'Chain length', required: true, optionsKey: 'chain' },
    ],
  },
  ring_size: {
    id: 'ring_size',
    label: 'Ring — pick size',
    fields: [
      { id: 'ring_size', type: 'select', label: 'Ring size', required: true, optionsKey: 'ring' },
    ],
  },
  bracelet_size: {
    id: 'bracelet_size',
    label: 'Bracelet / kada — pick size',
    fields: [
      { id: 'bracelet_size', type: 'select', label: 'Bracelet size', required: true, optionsKey: 'bracelet' },
    ],
  },
  photo_engraving: {
    id: 'photo_engraving',
    label: 'Photo + back engraving',
    fields: [
      { id: 'photo', type: 'photo', label: 'Photo', required: true },
      { id: 'engraving', type: 'text', label: 'Back engraving', required: true, maxLength: 30 },
    ],
  },
  name_engraving: {
    id: 'name_engraving',
    label: 'Name / initial engraving',
    hint: 'Customer types a name or initials to personalize the piece. Set the label, character limit, placeholder and helper text in product options below.',
    fields: [
      {
        id: 'name',
        type: 'text',
        label: 'Name or initial',
        required: true,
        maxLength: 20,
        placeholder: 'e.g. Aria',
        hint: 'Engraved exactly as typed.',
      },
    ],
  },
  engraving_only: {
    id: 'engraving_only',
    label: 'Custom engraving text',
    fields: [
      { id: 'engraving', type: 'text', label: 'Engraving text', required: true, maxLength: 40 },
    ],
  },
  band_color_name: {
    id: 'band_color_name',
    label: 'Band color + name / initial',
    hint: 'Customer picks a band color (with photos) and types a name or initial. Add each band color with its photo in product options below.',
    fields: [
      {
        id: 'band_color',
        type: 'select',
        label: 'Band color',
        required: true,
        swatches: true,
        options: [],
      },
      {
        id: 'name',
        type: 'text',
        label: 'Name or initial',
        required: true,
        maxLength: 20,
        placeholder: 'e.g. A',
        hint: 'Engraved exactly as typed.',
      },
    ],
  },
};
